import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CustomAxios } from "../../../services/api"
import { MiniHomeType } from "./minihome.type";
import { MiniHomeCard, MiniHomeCardImage, MiniHomeCardText, Container, Column, StyledDiv, VerticalCard } from "./minihome.style";
import 'bootstrap/dist/css/bootstrap.min.css';
import MiniMap from "../map/minimap"
import { Col, Divider, Row, Typography, Button } from "antd";
import React from "react";
import { CalendarOutlined } from '@ant-design/icons';
export default function MiniHome() {

    const { clubSeq } = useParams();

    useEffect(() => {
        console.log("clubSeq", clubSeq);
        requestGetClubInfos();
    }, [clubSeq]);
    const [miniHome, setMiniHome] = useState<MiniHomeType | null>(null);



    const handleReservation = () => {
        window.open(`/minihome/${clubSeq}/reservation`, "_blank");
    };


    const requestGetClubInfos = () => {
        CustomAxios.getClubOne(
            Number(clubSeq)
        ).then(
            (response) => {
                const miniHomeData: MiniHomeType = response.data;
                setMiniHome(miniHomeData);
                console.log("response.data ", response.data);
            },
            (error: any) => {
            }
        );
    };

    const brCheck = (str: string): React.ReactNode => {
        return str.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    }

    const onClickLink = (link: string) => {
        window.open(link, "_blank");
    };

    return (
        <div>
            {/* <MiniHomeCard backgroundImage={miniHome ? miniHome.imagePathCard : ''}> */}
            <MiniHomeCard backgroundImage={miniHome ? '' : ''}>
                <MiniHomeCardImage src="/asset/img/pattern.png" />
                <MiniHomeCardText>
                    <StyledDiv style={{ color: 'white', fontSize: 22 }}>{miniHome && miniHome.clubName}</StyledDiv>
                    {/* <Container>                   
                        <Column style={{width:'35%',color: 'white'}}>발급일</Column>
                        <Column style={{width:'35%',color: 'white'}}>유효기간</Column>
                    </Container>
                    <Container>                   
                        <Column style={{width:'35%',color: 'white'}}>{miniHome && miniHome.created.substring(0, 10)}</Column>
                        <Column style={{width:'35%',color: 'white'}}>{miniHome && miniHome.endDate.substring(0, 10)}</Column>
                    </Container> */}
                </MiniHomeCardText>
            </MiniHomeCard>

            <VerticalCard>
                <StyledDiv style={{ color: 'black', fontSize: 16 }}>운영자</StyledDiv>
                <Container>
                    <Column style={{ width: 50, color: 'black', height: 50 }}>
                        {miniHome && miniHome.issuer.profileFilePath && (
                            <img
                                className="rounded-circle"
                                src={miniHome.issuer.profileFilePath}
                                alt="Profile Image"
                                width="50"
                                height="50"
                                style={{ color: "black" }}
                            />
                        )}
                    </Column>
                    <Column style={{ width: 70, color: 'black', height: 50 }}>{miniHome && miniHome.issuer.memberName}</Column>
                    <Column style={{ width: '20%', color: 'black', height: 50 }}></Column>
                    {/* <Column style={{width:'30%',color: 'black', height: 50}}>카카오송금</Column>
                    <Column style={{width:'10%',color: 'black', height: 50}}>?</Column> */}
                </Container>
                <Divider orientation="left"></Divider>

                {/* <StyledDiv style={{color: 'black',fontSize: 16}}>계좌정보</StyledDiv>
                <Row>
                    <Col flex="auto" style={{display: 'flex', justifyContent: 'flex-start', marginLeft:20}}>국민 ∙ 10-000000-0000000 ∙ 이성철</Col>
                    <Col flex="100px" style={{display: 'flex', justifyContent: 'flex-start'}}><img src="/asset/img/ic_copy_black.png"/></Col>               
                </Row>
                <Divider orientation="left"></Divider> */}

                <StyledDiv style={{ color: 'black', fontSize: 16 }}>상세정보</StyledDiv>
                <Row>
                    <Col flex="100px" style={{ textAlign: 'left', marginLeft: 20 }}>운영시간</Col>
                    <Col flex="auto" style={{ textAlign: 'left', whiteSpace: 'pre-line' }}>
                        {miniHome && miniHome.operateTime.replaceAll("|", "\n").replaceAll(",", "\n")}
                    </Col>
                </Row>
                {/* <Row>                    
                    <Col flex="100px" style={{textAlign: 'left',  marginLeft:20}}>회비</Col>        
                    <Col  flex="auto" style={{textAlign: 'left'}}>{miniHome && miniHome.clubFee.feeValue}</Col>      
                </Row> */}
                <Row>
                    <Col flex="100px" style={{ textAlign: 'left', marginLeft: 20 }}>URL</Col>
                    <Col flex="auto" style={{ textAlign: 'left' }}>

                        <Typography.Link
                            onClick={() => miniHome && onClickLink(miniHome.clubUrl)}
                            style={{ color: "black", fontWeight: "bold" }}
                        >
                            {miniHome && miniHome.clubUrl}
                        </Typography.Link>

                    </Col>
                </Row>
                <Divider orientation="left"></Divider>


                <StyledDiv style={{ color: 'black', fontSize: 16 }}>소개</StyledDiv>
                <Row>
                    <Col flex="auto" style={{ textAlign: 'left', margin: 10 }}>
                        {miniHome && miniHome.description}
                    </Col>
                </Row>
                <Divider orientation="left"></Divider>


                <StyledDiv style={{ color: 'black', fontSize: 16 }}>소개이미지</StyledDiv>


                {/* 이미지1 */}
                {miniHome && miniHome.imagePath1 && (
                    <>
                        <Row>
                            <Col flex="auto" style={{ textAlign: 'left', margin: 10 }}>
                                <img src={miniHome.imagePath1} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col flex="auto" style={{ textAlign: 'left', margin: 10 }}>
                                {miniHome ? brCheck(miniHome.imageText1) : ''}
                            </Col>
                        </Row>
                        <Divider orientation="left"></Divider>
                    </>
                )}


                {/* 이미지2 */}
                {miniHome && miniHome.imagePath2 && (
                    <>
                        <Row>
                            <Col flex="auto" style={{ textAlign: 'left', margin: 10 }}>
                                <img src={miniHome.imagePath2} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col flex="auto" style={{ textAlign: 'left', margin: 10 }}>
                                {miniHome ? brCheck(miniHome.imageText2) : ''}
                            </Col>
                        </Row>
                        <Divider orientation="left"></Divider>
                    </>
                )}


                {/* 이미지3 */}
                {miniHome && miniHome.imagePath3 && (
                    <>
                        <Row>
                            <Col flex="auto" style={{ textAlign: 'left', margin: 10 }}>
                                <img src={miniHome.imagePath3} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col flex="auto" style={{ textAlign: 'left', margin: 10 }}>
                                {miniHome ? brCheck(miniHome.imageText3) : ''}
                            </Col>
                        </Row>
                        <Divider orientation="left"></Divider>
                    </>
                )}

                {/* 이미지4 */}
                {miniHome && miniHome.imagePath4 && (
                    <>
                        <Row>
                            <Col flex="auto" style={{ textAlign: 'left', margin: 10 }}>
                                <img src={miniHome.imagePath4} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col flex="auto" style={{ textAlign: 'left', margin: 10 }}>
                                {miniHome ? brCheck(miniHome.imageText4) : ''}
                            </Col>
                        </Row>
                        <Divider orientation="left"></Divider>
                    </>
                )}


                {/* 이미지5 */}
                {miniHome && miniHome.imagePath5 && (
                    <>
                        <Row>
                            <Col flex="auto" style={{ textAlign: 'left', margin: 10 }}>
                                <img src={miniHome.imagePath5} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col flex="auto" style={{ textAlign: 'left', margin: 10 }}>
                                {miniHome ? brCheck(miniHome.imageText5) : ''}
                            </Col>
                        </Row>
                        <Divider orientation="left"></Divider>
                    </>
                )}




                <StyledDiv style={{ color: 'black', fontSize: 16 }}>주소</StyledDiv>
                <Row>
                    <Col flex="auto" style={{ textAlign: 'left', marginLeft: 20 }}>
                        {miniHome ? miniHome.location.replaceAll("!^^!", " ") : ''}
                    </Col>
                </Row>

                {miniHome && (
                    <div style={{ marginTop: 20 }}>
                        <MiniMap
                            location={miniHome.location.replaceAll("!^^!", " ")}
                            name={miniHome.clubName}
                        />
                    </div>
                )}

            </VerticalCard>

            <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 100 }}>
                <Button type="primary" icon={<CalendarOutlined />} size="large" onClick={() => handleReservation()}>
                    온라인 예약하기
                </Button>
            </div>


        </div>
    );
}
